<template>
  <div>
    <generic-table
      ref="datatable"
      title="&nbsp;"
      :columns="columns"
      :column_search="false"
      resource_url="/credit-analysis/deny-reason/datatables"
    >
      <template v-slot:buttons>
        <button class="button is-secondary is-rounded" @click="create">
          <span class="icon"><i class="fa fa-plus"></i></span>
          <span>{{ $t("new reason") }}</span>
        </button>
      </template>
    </generic-table>

    <!-- Create/Edit Modal -->
    <reason-modal ref="modal" @saved="onSaved" />
  </div>
</template>

<script>
import GenericTable from "@/components/generic_table/GenericTable.vue";
import ReasonModal from "./reason_modal/Index.vue";
import {
  generate_datatables_buttons,
  confirm_deletion_dialog,
  del,
  success_message,
  error_message,
} from "@/utils";
import moment from "moment";

export default {
  name: "CreditAnalysisReasonsDatatable",
  components: {
    GenericTable,
    ReasonModal,
  },
  data() {
    return {
      columns: [
        {
          title: this.$t("name"),
          name: "name",
          searchable: true,
          // width: "25%",
          data: (row) => row.name || "",
        },
        {
          title: this.$t("status"),
          name: "status",
          searchable: false,
          // width: "12%",
          data: (row) => {
            const statusClass = this.getStatusClass(row.status);
            return `<span class="tag ${statusClass}">${this.$t(
              row.status || "pending"
            )}</span>`;
          },
        },
        // {
        //   title: this.$t("data"),
        //   searchable: false,
        //   // width: "12%",
        //   data: (row) => {
        //     return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
        //   },
        // },
        {
          title: this.$t("actions"),
          // width: "12%",
          data: (row) => {
            let v = this;
            let btns = [
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("edit"),
                icon: "fa fa-edit",
                icon_class: "is-small has-text-warning",
                click: (e) => {
                  v.$refs.modal.open(row.uuid);
                },
              },
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("delete"),
                icon: "fa fa-trash",
                icon_class: "is-small has-text-danger",
                click: (e) => {
                  let uuid = e.detail.uuid;
                  confirm_deletion_dialog(
                    v.$t("are you sure to delete deny reason?"),
                    v,
                    () => {
                      del("/credit-analysis/deny-reason", { uuid: uuid })
                        .then(() => {
                          v.refresh();
                        })
                        .catch((error) => {
                          error_message(error);
                        });
                    }
                  );
                },
              },
            ];

            return generate_datatables_buttons(btns);
          },
        },
      ],
    };
  },
  methods: {
    create() {
      this.$refs.modal.open();
    },
    edit(row) {
      this.$refs.modal.open(row.uuid);
    },
    view(row) {
      this.$refs.detail_modal.open(row.uuid);
    },
    refresh() {
      this.$refs.datatable.refresh();
    },
    onSaved() {
      this.refresh();
    },
    getStatusClass(status) {
      const classes = {
        inactive: "is-danger",
        active: "is-success",
      };
      return classes[status] || "is-dark";
    },
  },
  mounted() {
    this.refresh();
  },
};
</script>

<style scoped>
.field.is-horizontal {
  align-items: center;
}

.checkbox {
  white-space: nowrap;
}
</style>
